import React from 'react'
import Story from './Story'
import './StoryReel.css'

function StoryReel() {
    return (
        <div className='storyReel' >
            <Story 
            image="https://images.unsplash.com/photo-1615354475159-b7a2e2ae6ca3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MTR8MzY3ODkwMnx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60"
            profileSrc="https://images.unsplash.com/profile-1635589180125-ef516fe106beimage?dpr=1&auto=format&fit=crop&w=150&h=150&q=60&crop=faces&bg=fff"
            title="Diego Damato"
            />
            <Story 
            image="https://images.unsplash.com/photo-1595847675008-92fa0c8c68c1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjB8fG1lc3NpfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60"
            profileSrc="https://images.unsplash.com/photo-1619634496831-881dbe7b8eb0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MTV8MzY3ODkwMnx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60"
            title="bassam"
            />
            <Story 
            image="https://images.unsplash.com/photo-1638933807150-93e93292dbf0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwxN3x8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=60"
            profileSrc="https://images.unsplash.com/photo-1603415526960-f7e0328c63b1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8cHJvZmlsZSUyMHBpY3R1cmV8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60"
            title="Riki Ramdani"
            />
            <Story 
            image="https://images.unsplash.com/photo-1622124554338-be0c1bd33721?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTF8fHByb3RyYWl0JTIwcGhvdG9zfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60"
            profileSrc="https://images.unsplash.com/profile-1633099426268-73be09890e68image?dpr=1&auto=format&fit=crop&w=150&h=150&q=60&crop=faces&bg=fff"
            title="Carlos Magno"
            />
            <Story 
            image="https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8Zm9vZHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60"
            profileSrc="https://media.istockphoto.com/photos/side-view-profile-portrait-of-cute-african-american-girl-picture-id1311433805?b=1&k=20&m=1311433805&s=170667a&w=0&h=4E3A4q53KXSXM7EdT0pBZiAhkYA2vyGzsJemKNRxlBA="
            title="Eiliv Sonas"
            />
        </div>
    )
}

export default StoryReel
